import { Link } from "react-router-dom";
import {
  SCHOOL_UNIVERSITY_PATH,
  authLinksForSchoolUniversityPathway,
} from "@/lib/schoolUniversityPathway";
import { storeLoginResume } from "@/lib/loginResume";

const links = authLinksForSchoolUniversityPathway();

function rememberReturnToPathway() {
  storeLoginResume(SCHOOL_UNIVERSITY_PATH);
}

export default function SchoolUniversityPathway() {
  return (
    <div className="space-y-10" data-testid="school-university-pathway">
      <section className="hero-card space-y-4" aria-labelledby="school-uni-heading">
        <p className="text-sm uppercase tracking-wide text-muted-foreground">GDI Academy</p>
        <h1
          id="school-uni-heading"
          className="text-3xl sm:text-4xl font-bold leading-tight"
          data-testid="school-uni-heading"
        >
          School and university learner pathway
        </h1>
        <p className="text-base md:text-lg max-w-2xl hero-sub" data-testid="school-uni-lead">
          Educational theory and practical learning support for students in supervised driving
          programmes. This pathway is for study and practice — not a licence test or regulatory
          assessment.
        </p>
        <div className="flex flex-wrap gap-3 pt-2">
          <Link
            to={links.register}
            className="btn-accent"
            data-testid="school-uni-create-account"
            onClick={rememberReturnToPathway}
          >
            Create account
          </Link>
          <Link
            to={links.login}
            className="btn-outline-light"
            data-testid="school-uni-log-in"
            onClick={rememberReturnToPathway}
          >
            Log in
          </Link>
        </div>
      </section>

      <section className="card space-y-3" data-testid="school-uni-how-it-works">
        <h2 className="text-base md:text-lg font-semibold">How access works</h2>
        <ol className="list-decimal pl-6 space-y-2 text-muted-foreground">
          <li>Create a learner account or log in with your existing GDI Academy details.</li>
          <li>
            After sign-in, open your dashboard and choose <strong className="text-foreground">School / University</strong>{" "}
            when you are ready to enrol. Enrolment is manual — scanning this page does not assign
            you to a programme or instructor automatically.
          </li>
          <li>
            Follow your school or university supervision rules. GDI Academy does not replace
            institutional oversight or official NZTA requirements.
          </li>
        </ol>
      </section>

      <section className="card space-y-3" data-testid="school-uni-educational-notice">
        <h2 className="text-base md:text-lg font-semibold">Independent educational platform</h2>
        <p className="text-muted-foreground">
          GDI Academy is operated independently. It is not NZTA / Waka Kotahi and does not issue
          licences or official test results. Content supports learning; always refer to the official
          New Zealand Road Code for regulatory requirements.
        </p>
        <p className="text-sm text-muted-foreground">
          Instructor-led practical training, where offered, requires a confirmed assignment through
          your institution or GDI — not through this QR page alone.
        </p>
      </section>

      <section className="card space-y-3" data-testid="school-uni-account-help">
        <h2 className="text-base md:text-lg font-semibold">Account help</h2>
        <div className="flex flex-wrap gap-4 text-sm">
          <Link
            to={links.forgotPassword}
            className="underline"
            data-testid="school-uni-forgot-password"
          >
            Forgot password
          </Link>
          <Link to={links.privacy} className="underline" data-testid="school-uni-privacy">
            Privacy Notice
          </Link>
          <Link to={links.terms} className="underline" data-testid="school-uni-terms">
            Terms
          </Link>
          <Link to="/" className="underline" data-testid="school-uni-home">
            GDI Academy home
          </Link>
        </div>
      </section>
    </div>
  );
}
